import React, {useEffect} from "react"
import Styles from "./mask.less"
import {Lottie} from "@crello/react-lottie"
import loadingCheck from "../../static/pic/小K状态/检测状态/检测状态.json"
import ShowMask from "../../function/hooks/showMask"
import {connect} from "react-redux"
import {ReducerState} from "../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../reducer/interface/controlInterface"

interface TDAMaskProps {
    comparisonStatus: ComparisonStatus
}

const TDAMask: React.FunctionComponent<TDAMaskProps> = ({comparisonStatus}) => {
    const showMask = ShowMask()
    // showMask.init()
    useEffect(() => {
        if (comparisonStatus.status === "success" || comparisonStatus.status === "error") {
            showMask.toFalse()
        }
    }, [comparisonStatus])
    return showMask.value ? (
        <div className={Styles.Mask}>
            <Lottie width="120px" height="120px" config={{animationData: loadingCheck, loop: true, autoplay: true}} />
            <span style={{color: "#666666"}}>正在加载中</span>
        </div>
    ) : null
}

export default connect((state: ReducerState) => {
    return {
        comparisonStatus: state.control.comparisonStatus,
    }
})(TDAMask)
